import React from "react";
import useOkendo from "hooks/useOkendo";
import clsx from "clsx/lite";

const coordinates = [3.34, 21.05, 38.76, 56.47, 74.18];

const Stars = ({ filled, width, color }) => (
	<svg height="18" viewBox="0 0 85.44444444444444 14" 
		className={clsx(width ? width : "w-12 xs:w-16 md:w-20")} aria-hidden="true">
		{coordinates.map((x, i) => <path key={i}
			d={`M${x},13.86 c-.48,.3-.76,.1-.63,-.44 l1.08,-4.56 l-3.08,-3.22 c-.42,-.36,-.32,-.7,.24,-.74 l4.63,-.37 
			l1.82,-4.32 c.2,-.52,.55,-.52,.76,0 l1.82,4.32 l4.63,.37 c.56,.05,.67,.37,.24,.74 
			l-3.08,3.22 l1.08,4.56 c.13,.54,-.14,.74,-.63,.44 l-3.75,-2.43z`}
			fill={color ? color : filled ? "#FAD201" : "#DDDDDD"}
		/>)}
	</svg>
);

const OkendoStarRating = ({ reviewAggregate, productId, className = "", 
	customText = null, removeParenthesis = false, starsColor = "", starsWidth = "" }) => {
	if (!reviewAggregate && productId) {
		const widgetContainer = useOkendo();

		return (
			<div
				ref={widgetContainer}
				data-oke-star-rating
				data-oke-reviews-product-id={`shopify-${productId}`}
				className={clsx(className, "small-size-rating relative")}
			></div>
		);
	}

	return (
		<div className={clsx(className, "flex gap-2 items-center")} aria-label={`${reviewAggregate?.reviewCount} Reviews`}>
			<div className="relative">
				<Stars width={starsWidth} color={starsColor}/>
				<div className="foreground absolute top-0 left-0 overflow-hidden z-[5]"
					style={{ width: `${Math.ceil(reviewAggregate?.averageRating / 5 * 100)}%` }}>
					<Stars filled width={starsWidth} color={starsColor}/>
				</div>
			</div>
			{reviewAggregate && <span className="text-xs md:text-sm font-t59">{removeParenthesis ? 
				reviewAggregate.reviewCount : `(${reviewAggregate.reviewCount})`}</span>}
			{customText && <span className="text-sm -ml-1">{customText}</span>}
		</div>
	);
};

export default OkendoStarRating;
